import { useMemo } from 'react';
import { pipe } from 'fp-ts/function';
import { array, record } from 'fp-ts';
import {
    PromotedServiceAssignment,
    PromotedServiceAssignmentReservationIntervalLimit,
    PromotedServiceAssignmentUnitCountLimit,
} from '@mews-commander/data-access';
import { FormFields, FormValues, OptionsNames } from '../../../schema';

const defaultOptionsArray = [OptionsNames.InBookingEnging, OptionsNames.DuringOnlineCheckin];
export const getCheckedOptions = (options: Record<OptionsNames, boolean>) =>
    pipe(
        record.keys(options),
        array.filter((key) => options[key])
    );

export const useGetInitialFormValues = (isEditMode: boolean, promotedService?: PromotedServiceAssignment) => {
    const optionValues = promotedService?.promotedServiceAssignmentOptions;

    return useMemo(
        (): FormValues => ({
            [FormFields.PromotedServiceId]: promotedService?.promotedServiceId || '',
            [FormFields.Enabled]: isEditMode ? !!promotedService?.isEnabled : true,
            [FormFields.PromotedResourceCategoryId]: promotedService?.promotedResourceCategoryId || '',
            [FormFields.PromotedRateId]: promotedService?.promotedRateId || '',
            [FormFields.Options]: optionValues ? getCheckedOptions(optionValues) : defaultOptionsArray,
            [FormFields.UnitCountLimit]:
                promotedService?.unitCountLimit || PromotedServiceAssignmentUnitCountLimit.PerGuest,
            [FormFields.ReservationIntervalLimit]:
                promotedService?.reservationIntervalLimit ||
                PromotedServiceAssignmentReservationIntervalLimit.SameAsParent,
            [FormFields.Ordering]: promotedService?.ordering || 0,
        }),
        [isEditMode, optionValues, promotedService]
    );
};
